
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_195_25189)"}},[_c('path',{attrs:{"d":"M38.313 13.355c0 2.173-2.663 2.044-2.663 2.044h-2.663v-3.927h2.663c2.74-.019 2.663 1.883 2.663 1.883zm-5.326-7.873h2.03c2.106.114 2.027 1.707 2.027 1.707 0 1.98-2.33 2.012-2.33 2.012h-1.727V5.482zm4.834 4.491s1.822-.788 1.806-2.88c0 0 .277-3.43-4.196-3.848h-4.963V17.62h5.689s4.754.015 4.754-4.056c0 0 .112-2.77-3.09-3.59zM24.976.428h20.896V20.43H24.976v-20zm-10.76 12.927c0 2.173-2.663 2.044-2.663 2.044H8.89v-3.927h2.663c2.74-.019 2.663 1.883 2.663 1.883zM8.89 5.482h2.03c2.107.114 2.027 1.707 2.027 1.707 0 1.98-2.33 2.012-2.33 2.012H8.89V5.482zm4.833 4.491s1.823-.788 1.807-2.88c0 0 .277-3.43-4.196-3.848H6.37V17.62h5.69s4.754.015 4.754-4.056c0 0 .111-2.77-3.09-3.59zM.878.428h20.897V20.43H.878v-20zm64.829 3.848V6.93s-2.553-1.593-5.373-1.625c0 0-5.262-.105-5.5 5.123 0 0-.19 4.808 5.436 5.082 0 0 2.36.29 5.563-1.785v2.75s-4.295 2.593-9.272.596c0 0-4.183-1.551-4.342-6.643 0 0-.174-5.236 5.405-6.974 0 0 1.49-.58 4.167-.322 0 0 1.6.16 3.916 1.143zM49.073 20.429h20.896v-20H49.073v20z","fill":"#E6E7E9"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_195_25189"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.878 .428)","d":"M0 0h69.091v20H0z"}})])])])
          )
        }
      }
    